module.exports = __webpack_public_path__ + "static/media/c1bannerModul2_small.aee881b7.jpg";